import { RadioGroup } from '@/components/RadioGroup';
import { selectExpensesShared, setExpensesShared } from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { getBoolean } from '@/utils/valueFormat';

export interface IShareExpenses {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'ShareExpenses';

export function ShareExpenses({
    baseId,
    showErrors,
}: IShareExpenses): JSX.Element {
    // ***** Redux *****
    const shareExpenses = useAppSelector(selectExpensesShared);
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean | undefined): void {
        const booleanValue = getBoolean(value);
        dispatch(setExpensesShared(booleanValue));
    }

    // ***** Render *****
    const options = [
        {
            label: 'Yes',
            value: 'true',
            id: `${baseId}-button-shareExpenses-yes`,
        },
        {
            label: 'No',
            value: 'false',
            id: `${baseId}-button-shareExpenses-no`,
        },
    ];
    return (
        <div data-testid={testId}>
            <RadioGroup
                title='Do you share household expenses?'
                showErrors={showErrors && shareExpenses === undefined}
                onChange={handleChange}
                options={options}
                value={`${shareExpenses}`}
                tooltipContent="Only select 'Share' if you share expenses with a spouse who also earns an income."
            />
        </div>
    );
}
